import { useToggle } from "react-use"
import { PropsWithChildren } from "react"

import { Button, Modal, Text } from "ui-kit/components-branded/index"

export function InstructionsPopup({ children }: PropsWithChildren<unknown>) {
    const [show, toggle] = useToggle(false)
    return (
        <>
            <Button isLikeLink isInlineLink onClick={toggle} className="instructions-popup__link">
                {children}
            </Button>
            <Modal onBackgroundClick={toggle} isActive={show}>
                <Modal.Content
                    className="instructions-popup flex-column justify-content-between"
                    isFullHeightMobile
                    data-testid="call-instruction-modal"
                >
                    <div>
                        <h4 className="instructions-popup__headline">Свет</h4>
                        <Text>Создайте равномерное мягкое освещение без резких теней.</Text>
                        <h4 className="instructions-popup__headline">Камера</h4>
                        <Text>
                            Установите камеру на&nbsp;уровне глаз, чтобы ваше лицо было хорошо
                            видно.
                        </Text>
                        <h4 className="instructions-popup__headline">Звук</h4>
                        <Text>
                            Исключите источники постороннего шума. Если вы&nbsp;используете
                            беспроводные устройства&nbsp;&mdash; убедитесь, что они заряжены
                            и&nbsp;подключены. Выберите источник звука, если необходимо.
                        </Text>
                        <h4 className="instructions-popup__headline">Фон</h4>
                        <Text>
                            Используйте однородный или нейтральный фон. Если в&nbsp;кадре виден
                            интерьер&nbsp;&mdash; убедитесь, что он&nbsp;прибран.
                        </Text>
                    </div>
                    <Button
                        isFullwidth
                        onClick={toggle}
                        className="after-call__transparent-button mgt-2"
                    >
                        Закрыть
                    </Button>
                </Modal.Content>
            </Modal>
        </>
    )
}
